import { SourcesData, NewsData, Callback } from '../../types/interfaces';
import { AppLoader } from './appLoader';

export class AppController extends AppLoader {
    getSources(callback: Callback<SourcesData>):void {
        super.getResp(
            {
                endpoint: 'top-headlines/sources',
            },
            callback
        );
    }

    getNews(e: MouseEvent, callback: Callback<NewsData>):void {
        let target = e.target as HTMLElement;
        const newsContainer = e.currentTarget as HTMLElement;

        while (target !== newsContainer) {
            if (target.classList.contains('source__item')) {
                const sourceId = target.getAttribute('data-source-id') as string;
                if (newsContainer.getAttribute('data-source') !== sourceId) {
                    newsContainer.setAttribute('data-source', sourceId);
                    document.querySelectorAll('.source__item').forEach((sourseItem):void => {
                        sourseItem.classList.remove('active');
                    });
                    target.classList.add('active');
                    super.getResp(
                        {
                            endpoint: 'everything',
                            options: {
                                sources: sourceId,
                                pageSize: 10,
                            },
                        },
                        callback
                    );
                }
                return;
            }
            target = target.parentNode as HTMLElement;
        }
    }
}
